import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import DateRange from 'components/Form/DateRange';
import { LegalAssociationsEngagedTerrorismItemModel } from 'forms/sections/legal/associations/engagedTerrorism/types';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnError,
  CommonOnUpdate,
  CommonRequired,
  CommonScrollIntoView,
} from '../../../../types/props';

interface Props
  extends Partial<LegalAssociationsEngagedTerrorismItemModel>,
    ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
}

export default class EngagedInTerrorismItem extends ValidationElement<Props> {
  update = (queue: Partial<LegalAssociationsEngagedTerrorismItemModel>) => {
    this.props.onUpdate({
      Reasons: this.props.Reasons,
      Dates: this.props.Dates,
      ...queue,
    });
  };

  updateReasons = (values: LegalAssociationsEngagedTerrorismItemModel['Reasons']) => {
    this.update({
      Reasons: values,
    });
  };

  updateDates = (values: LegalAssociationsEngagedTerrorismItemModel['Dates']) => {
    this.update({
      Dates: values,
    });
  };

  render() {
    const attribute = `List.items[${this.props.$index}].Item`;

    return (
      <div>
        <Field
          title={i18n.t('legal.associations.engaged.heading.reasons')}
          adjustFor="textarea"
          attribute={`${attribute}.Reasons`}
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            name="Reasons"
            attribute={`${attribute}.Reasons`}
            {...this.props.Reasons}
            onUpdate={this.updateReasons}
            onError={this.props.onError}
            className="legal-associations-engaged-reasons"
            required={this.props.required}
          />
        </Field>

        <Field
          title={i18n.t('legal.associations.engaged.heading.dates')}
          help="legal.associations.engaged.help.dates"
          adjustFor="daterange"
          attribute={`${attribute}.Dates`}
          scrollIntoView={this.props.scrollIntoView}
        >
          <DateRange
            name="Dates"
            attribute={`${attribute}.Dates`}
            {...this.props.Dates}
            minDateEqualTo
            onUpdate={this.updateDates}
            onError={this.props.onError}
            className="legal-associations-engaged-dates"
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>
      </div>
    );
  }
}

EngagedInTerrorismItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
};
